// extracted by mini-css-extract-plugin
export default {"root":"ToggleExpandButton_root__TGM6-","rootExpanded":"ToggleExpandButton_rootExpanded__L8YfC ToggleExpandButton_root__TGM6-"};